/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class e{constructor(e){this.data=e,this._referenceCount=0}static{this.estimatedMemory=20}increment(){this._referenceCount+=1}decrement(){this._referenceCount-=1}get empty(){return 0===this._referenceCount}}export{e as RefCounted};
